import React, { Fragment } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ArrowRight from "@material-ui/icons/KeyboardArrowRight";
import DotIcon from "@material-ui/icons/Lens";

const FilterContainer = (props) => {
  const {
    classes,
    toggleFilterGroupVisibility,
    isFilterGroupActive,
    renderFilterItem,
    filterObject,
    filterGroups,
    isLoading,
  } = props;
  if (isLoading) {
    return (
      <div className={classes.message}>Please wait while loading filters</div>
    );
  }
  if (!filterObject) {
    return (
      <div className={classes.message}>Error while fetching quick filters</div>
    );
  }
  if (!filterGroups) {
    return <div className={classes.message}> No filters available </div>;
  }
  return (
    <div className={classes.container}>
      {filterObject && (
        <List classes={{ root: classes.filterListContainer }}>
          {filterGroups &&
            Object.keys(filterGroups).map((filterGroupkey) => {
              const filterGroup = filterGroups[filterGroupkey];
              return (
                <Fragment key={filterGroup.groupName}>
                  <ListItem
                    onClick={() =>
                      toggleFilterGroupVisibility({
                        groupKey: filterGroupkey,
                      })
                    }
                    classes={{ root: classes.filterGroupItem }}
                  >
                    <ListItemIcon classes={{ root: classes.listItemIcon }}>
                      {props[`${filterGroupkey}_isOpen`] ? (
                        <ExpandMore color="primary" />
                      ) : (
                        <ArrowRight color="primary" />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      classes={{
                        root: classes.filterGroupTextRoot,
                        primary: classes.filterGroupText,
                      }}
                    >
                      {filterGroup.groupName}
                    </ListItemText>
                    {isFilterGroupActive(filterGroup) &&
                      !props[`${filterGroupkey}_isOpen`] && (
                        <DotIcon
                          color="primary"
                          classes={{ root: classes.dotIcon }}
                        />
                      )}
                  </ListItem>
                  <Collapse
                    in={props[`${filterGroupkey}_isOpen`]}
                    classes={{
                      container: classes.collapseContainer,
                      wrapper: classes.filtersContainer,
                    }}
                  >
                    {filterGroup.filters &&
                      filterGroup.filters.map((filter) =>
                        renderFilterItem(filter)
                      )}
                  </Collapse>
                </Fragment>
              );
            })}
        </List>
      )}
    </div>
  );
};
export default FilterContainer;
